import React, { useEffect } from "react";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import './CurrentPriceStyles.css';
import { useHistory } from "react-router-dom";
import { Card, Col, Row, Table } from "react-bootstrap";
import { getPriceHistory } from "../../../apis/options/StockPriceApi";
import Dollars from "../../common/typeFormatting/Dollars";
import DateFmt from "../../common/typeFormatting/Date";
import YesNoFmt from "../../common/typeFormatting/YesNoFmt";


export default function CurrentPricePage() {

  const [priceHistory, setPriceHistory] = useState(null);
  const [isPricesLoading, setIsPricesLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    async function getPrices() {
        try {
            const prices = await getPriceHistory();
            prices.sort((a,b) => new Date(b.effectiveStart) - new Date(a.effectiveStart));

            setPriceHistory(prices);
            setIsPricesLoading(false);
        } catch(error) {
            console.log(error);
        }
    }

    getPrices();

  }, []);

  const goToAddPrice = _ => {
        history.push(`/options/stockprice/add`);
    }

    const priceSelected = (priceId) => {
        history.push(`/options/stockprice/${priceId}`);
    }

  return (
    <>
    <Row>
        <Col>
            <Row>
                <Col>
                    <Card style={{ width: '18rem' }}>
                    <Card.Body>
                        <Card.Title>
                            Stock Price History
                            <Button onClick={goToAddPrice}>New Price</Button>
                        </Card.Title>
                        <Card.Text>
                            <Table hover responsive style={{fontSize: 12, overflowY: "auto"}} >
                                <thead style={{position: "sticky", top: 0}}>
                                    <tr>
                                        <th>Price</th>
                                        <th>Effective Start</th>
                                        <th>Effective End</th>
                                        <th>Is Current Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isPricesLoading ?
                                        <tr><td>Loading prices...</td></tr>
                                        :
                                        priceHistory.map(p => (
                                            <tr key={p.stockPriceId} onClick={() => priceSelected(p.stockPriceId)}>
                                                <td><Dollars>{p.price}</Dollars></td>
                                                <td><DateFmt>{p.effectiveStart}</DateFmt></td>
                                                <td><DateFmt>{p.effectiveEnd}</DateFmt></td>
                                                <td><YesNoFmt>{p.isCurrent}</YesNoFmt></td>
                                            </tr>                                            
                                        ))
                                    }                                                  
                                </tbody>
                            </Table>
                        </Card.Text>
                    </Card.Body>
                    </Card>            
                </Col>
            </Row>     
        </Col>
    </Row>

    
    </>



  );
}